import {reactive, type Component, markRaw} from "vue";

interface ModalState {
  visible: boolean;
  component: Component | null;
  props: Record<string, any>;
}

const state = reactive<ModalState>({
  visible: false,
  component: null,
  props: {},
});

export function showModal(component: Component, props: Record<string, any> = {}) {
  state.visible = true;
  state.component = markRaw(component);
  state.props = props;
}

export function hideModal() {
  state.visible = false;
  state.component = null;
  state.props = {};
}

export function useModal() {
  return {
    state,
    showModal,
    hideModal,
  };
}
